<template>
	<div class="q_pad_lr15px q_mar_t15px">
		<van-tabs @click="onClick"  swipe-threshold="1">
			<van-tab title="全部" name="1">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
					<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						error-text="请求失败，点击重新加载">
						<div class="q_lame" @click="goToArtdea(item.id)" v-for="item in list" :key="item.id">
							<van-image fit="cover" :src="item.pic" />
							<div class="q_text_m q_bold q_mar_t10px q_moit2 q_justify q_moit1">{{ item.name }}</div>
							<div class="q_color_gray q_text_s q_mar_t10px q_mar_b15px">{{ item.publishTime }}</div>
						</div>
					</van-list>
				</van-pull-refresh>

				<!--空数据-->
				<div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
					<img src="@/assets/image/none.png" style="width: 26vw;" />
					<p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
				</div>
			</van-tab>
      <div v-for="item in trainTypeList">
			<van-tab :title="item.courseName" :name="item.id">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
					<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						error-text="请求失败，点击重新加载">
						<div class="q_lame" @click="goToArtdea(item.id)" v-for="item in list" :key="item.id">
							<van-image fit="cover" :src="item.pic" />
							<div class="q_text_m q_bold q_mar_t10px q_moit2 q_justify q_moit1">{{ item.name }}</div>
							<div class="q_color_gray q_text_s q_mar_t10px q_mar_b15px">{{ item.publishTime }}</div>
						</div>
					</van-list>
				</van-pull-refresh>

				<!--空数据-->
				<div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
					<img src="@/assets/image/none.png" style="width: 26vw;" />
					<p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
				</div>
			</van-tab>
      </div>
		</van-tabs>
		<!--      <div class="q_center q_mar_t70px" v-if="list.length==0">-->
		<!--        <img src="@/assets/image/none.png" style="width: 26vw;"/>-->
		<!--        <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>-->
		<!--      </div>-->
	</div>
</template>

<script>
	import {
		listTrain,
		upTrainById
	} from "@/api/train";
	import {
		upArticleById
	} from "@/api/article";
  import {listTrainType} from "@/api/trainType";
  import {wxCloseShare} from "@/utils/jiutang";

	export default {
		name: 'Lame',
		props: {
			msg: String
		},
		data() {
			return {
				showEmpty: false,
				refreshing: false,
				loading: false,
				finished: false,
				list: [],
				pageParam: {
					pageNum: 0,
					pageSize: 5,
          trainTypeId:''
				},
        trainTypeList:[]
			}
		},
    created() {
      wxCloseShare()
      //获取
      this.getTrainType()
    },
    methods: {
      /**
       * 获取一级分类菜单
       */
      getTrainType(){
        listTrainType().then((res)=>{
          this.trainTypeList = res.rows
        })
      },
			/**
			 * 下拉刷新
			 */
			onRefresh() {
        this.pageParam.pageNum = 0
        this.pageParam.pageSize = 5
				// 清空列表数据
				this.finished = false
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true
				this.onLoad()
			},
			/**
			 * 下滑加载更多
			 */
			onLoad() {
				this.pageParam.pageNum++
				if (this.pageParam.pageNum == 1) {
					this.$modal.loading()
				}
				//查询活动信息列表
				listTrain(this.pageParam).then(res => {
					if (res.total == 0) {
						this.showEmpty = true
					}else {
            this.showEmpty = false
          }
					//是否下拉刷新
					if (this.refreshing) {
						this.list = [];
						this.refreshing = false;
					}
					for (let i = 0; i < res.rows.length; i++) {
						this.list.push(res.rows[i]);
					}
					// 加载状态结束
					this.loading = false;

					// 数据全部加载完成
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				}).finally(() => {
					this.$modal.closeLoading()
				})
			},
			goToArtdea(id) {
				upTrainById(id).then(res => {
					this.$router.push({
						path: '/home/Lamedea',
						query: {
							id: id
						}
					});
				})
			},
      /**
       * 分类点击事件
       */
      onClick(name, title) {
        //清空列表数据
        if (name == '1'){
          this.list = []
          this.pageParam.trainTypeId = ''
        }else {
          this.list = []
          //每次点击清空列表，重置查询条件
          this.pageParam.trainTypeId = name
        }
        this.onRefresh()

      },
		}
	}
</script>
<style scoped>
	.q_lame {
		display: inline-block;
		width: 50%;
	}

	.q_lame:nth-child(2n-1) {
		padding-right: 7px;
	}

	.q_lame:nth-child(2n) {
		padding-left: 7px;
	}

	.q_lame>>>.van-image {
		width: 165.5px;
		height: 93px;
	}

	.q_lame>>>.van-image .van-image__img {
		border-radius: 5px;
	}

	.q_moit1 {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	>>>.van-tab--active {
		font-weight: 700;
		font-size: 16px;
	}

	>>>.van-tabs__line {
		background-color: #FF5733;
		height: 6px;
		border-radius: 3px;
		width: 30px;
	}

	>>>.van-tabs__content {
		margin-top: 50px;
	}

	>>>.van-tabs__wrap {
		position: fixed;
		top: 0;
		z-index: 1;
		width: 100%;
		padding-bottom: 6px;
	}
</style>
